import script from "./PaymentSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentSection.vue?vue&type=script&setup=true&lang=js"

import "./PaymentSection.vue?vue&type=style&index=0&id=4a326c74&lang=css"

const __exports__ = script;

export default __exports__